import { Switch, Tooltip } from "@mantine/core";

import { UNSUPPORTED } from "../../../platform/media/ImageRefsSlot";
import type { Composer } from "../composer/use-composer";
import classes from "./shots.module.css";

/**
 * Live's "Multi-Shot" switch (#230), under the prompt: shown for a model with a mode that makes
 * multi-shot video, greyed with live's words where the current mode does not. On, the shots
 * replace the prompt and the length; off brings them back, and the shots wait as they were.
 */
export function MultiShotSwitch({ c }: { c: Composer }) {
  if (!c.multiShotOffered) return null;
  const unsupported = c.multiShot === null;
  return (
    <Tooltip label={UNSUPPORTED} disabled={!unsupported} withArrow>
      <span className={classes.switch}>
        <Switch
          label="Multi-Shot"
          checked={c.draft.multiShot && !unsupported}
          disabled={unsupported}
          onChange={(event) => c.set({ multiShot: event.currentTarget.checked })}
        />
      </span>
    </Tooltip>
  );
}
